import { FormikErrors } from 'formik';

export const hasErrors = <T>(errors: FormikErrors<T>): boolean => Object.keys(errors).length > 0;
